import React from "react";
import TOCModuleSubtopic from "../TOCModuleSubtopic";

const ModuleSubtopicNormalFormsCFG = () => (
  <TOCModuleSubtopic
    title="Normal Forms for CFG: CNF and GNF"
    videos={[
      "https://www.youtube.com/embed/zTNm1nzDKUg",
      "https://www.youtube.com/embed/fbdrtzbEOG8",
      "https://www.youtube.com/embed/7G0PwGrdlH8",
      "https://www.youtube.com/embed/G_xUKj1oGL8",
    ]}
    takeaways={[
      { text: "CNF is more important than GNF." },
      { text: "For a grammar to be converted to GNF, it should first be in CNF. So, whenever a question asks to change to GNF, first check whether the grammar is in CNF or not." },
    ]}
    questions={[
      {
        text: "Convert the following CFG into an equivalent CFG in Chomsky Normal Form. Consider G={V,T,P,S} where V={S,A,B}, T={a,b}, and P consists of...",
        image: "/image5.png",
      },
      {
        text: "Convert the following CFG into Greibach Normal Form. Consider G={V,T,P,S} where V={S,X,A,B}, T={a,b}, S is the start symbol of the Grammar, and P consists of the following...",
        image: "/image6.png",
      },
    ]}
    exampleVideos={[]} // Add example question videos if needed
  />
);

export { ModuleSubtopicNormalFormsCFG };
